
// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

// Handles the clicking of the SELECT button when issueing assets to BOMS

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "vlreadhistory" ]
  static values = {
    data: Array,
    background: String,
  }

  connect() {
    let vlSpec = {
      $schema: 'https://vega.github.io/schema/vega-lite/v5.json',
      data: {
        values: this.dataValue,
      },
      background: this.backgroundValue,
      width: 'container',
      transform: [
        {
          fold: [
            "unmatched",
            "session_reads"
          ],
          as: [
            "key",
            "reads"
          ]
        }
      ],
      mark: 'bar',
      encoding: {
        x: {
          field: "date",
          type: "nominal",
          title: "",
          sort: null
        },
        y: {
          field: "reads",
          type: "quantitative",
          title: "Camera Reads",
          sort: ["session_reads", "unmatched"]
        },
        tooltip: [
          {
            field: "sessions",
            type: "quantitative",
            title: "Sessions"
          },
          {
            field: "unmatched",
            type: "quantitative",
            title: "Unmatched/Open"
          },
          {
            field: "perf_perc",
            type: "quantitative",
            title: "Perf %"
          },
        ],
        color: {
          field: "key",
          type: "nominal",
          scale : {
            domain: ["unmatched","session_reads"],
            range: ["Green","grey"],
          }
        }
      },
    };
    
    vegaEmbed(this.vlreadhistoryTarget, vlSpec, {"actions": false});
  }
}
